import React from 'react';

import { useLocationContext } from 'state/location';
import { routes } from 'utils/routing';

import { Footer as FooterContent } from './footer';

export const Footer = () => {
  const {
    location: { pathname },
  } = useLocationContext();

  // hiding footer on sign up / login flow
  if (
    pathname === routes.signUp ||
    pathname === routes.signIn ||
    pathname === routes.confirmOtp ||
    pathname === routes.waitingPayment
  ) {
    return null;
  }

  return <FooterContent />;
};
